/**
 * Storage types for personnel domain
 * @module domains/personnel/infrastructure/storage/types
 */

// EmployeeFiltersStorage lives in the application layer so composition and
// presentation can share it without importing infrastructure. Re-exported here
// for the infrastructure storage implementation's convenience.
export type { EmployeeFiltersStorage } from '@personnel/application/storage/types';

/**
 * Storage keys for personnel domain
 * Following namespace convention: parrot:{domain}:{key}
 */
export const PERSONNEL_STORAGE_KEYS = {
  EMPLOYEE_FILTERS: 'parrot:personnel:employee-filters',
  ROLE_FILTERS: 'parrot:personnel:role-filters',
} as const;
